/**
 * Default multi-series palette for Telloport-default charts.
 * Navy then brand-accent (teal) first; at most 5 colors. Semantic charts (waiting-days,
 * certifications) keep their own status-aware palettes.
 */
export const CHART_COLORS = [
    'var(--color-brand-secondary)',
    'var(--color-brand-accent)',
    'var(--color-brand-muted)',
    'var(--color-status-warning)',
    'var(--color-status-success)'
] as const;
